import StaffNotesDialog from './StaffNotesDialog';

export default StaffNotesDialog;
